import React from 'react'
import { Paper, Typography } from '@common/components'
import { CenterContainer } from '@common/containers'
import { LoginForm } from '@features/auth/components'
import { ThemeProvider } from '@common/utils/styles'
import unswLogo from '@assets/images/mentorai_yellow.png'
import { useTranslation } from 'react-i18next'
import lightThemeUnsw from '@styles/themes/unsw-light-theme'

const Login: React.FC = () => {
  const { t } = useTranslation('login-page')
  return (
    <ThemeProvider theme={lightThemeUnsw}>
      <CenterContainer>
        <Paper sx={{ py: 5, borderRadius: '20px' }}>
          <img
            src={unswLogo}
            alt={'unsw'}
            style={{
              display: 'block',
              width: '190px',
              margin: '0 auto',
              marginBottom: '22px',
            }}
          />

          <Typography variant='h6' align='center' sx={{ mb: 2 }}>
            {t('title', 'Sign in')}
          </Typography>
          <LoginForm />
        </Paper>
      </CenterContainer>
    </ThemeProvider>
  )
}

export default Login
